import React from "react";
import NsDashboardCard from "../../../components/NsDashboardCard";
import Translate from "../../../components/Translate";
import {getDataFormattata} from "../../../utility/common";

export default function DashboardScadenzeView({
                                                  scadenze,
                                                  translate,
                                                  history,
                                              }) {

    return (
        <NsDashboardCard
            title={translate('Scadenze')}
            classiAggiuntive={"ns-card--h340 ns-card--h340--padding-sm"}
        >
            {
                scadenze.length === 0 ?
                    <div className="sost-dashboard-text-center">
                        <Translate>Nessuna scadenza da visualizzare</Translate>
                    </div>
                    :
                    <div className={"ns-overflow-y-auto h-100 pe-2 ps-2"}>
                        {
                            scadenze.map((n, idx) => {
                                    let class_dett = "pe-1 "
                                    let title_dett = ""
                                    if (n.inscadenza_scaduto === 'SCAD') {
                                        class_dett += "fa-solid fa-triangle-exclamation ns-testo--rosso fa-lg";
                                        title_dett = translate("Scaduto");
                                    } else {
                                        class_dett += "fa-solid fa-triangle-exclamation ns-testo--giallo fa-lg";
                                        title_dett = translate("In Scadenza");
                                    }
                                    return (
                                        <div
                                            key={idx}
                                            className="row sost-stato-kpi w-100 ns-riga--notifiche ns-mouse-pointer"
                                            onClick={() => {
                                                history.push("/info-kpi/" + n.id_kpi + '/' + n.id_tipo_imp_dati)
                                            }}
                                            title={title_dett}
                                        >
                                            <div className="col-xl-4 col-md-12">
                                                <i className={class_dett}></i>
                                                <span>{getDataFormattata(n.data_scad)}</span>
                                            </div>
                                            <div className="col-xl-8 col-md-12">
                                                {n.codice} - {n.descrizione} - {n.descr_dett}
                                            </div>
                                        </div>
                                    )
                                }
                            )
                        }
                    </div>

            }
        </NsDashboardCard>
    );
}